import Page from './index';

export default { path: '/home/tenant/walletConfig', component: Page };
